<script>
export default {
    name: 'IconDone',
}
</script>
<template>
    <svg class="base-icon icon-done" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64"><path fill="currentColor"  fill-rule="evenodd" d="M58.353 9 64 14.73 30.036 49.188l.081.082L24.471 55 0 30.172l5.647-5.73L24.389 43.46 58.353 9Z" clip-rule="evenodd"/></svg>
</template>
